<template>
    <div class="hris-page">
        <div class="hris-page-inner">
            <div class="hris-page-header">
                <span class="hris-page-eyebrow">Employee Management</span>
                <h1 class="hris-page-title">Exit Interview</h1>
                <p class="hris-page-subtitle">Look up a separating employee and record their exit interview responses.</p>
            </div>

            <div class="hris-toolbar">
               <q-form @submit="searchEmployee" class="row items-start" style="gap: 12px; width: 100%;">
                 <q-input v-model="employee_id" outlined dense color="green" label="Employee ID" style="min-width: 220px;"></q-input>
                 <q-btn unelevated class="hris-q-primary" label="Search Employee" type="submit"></q-btn>
               </q-form>
            </div>

            <div class="hris-form-section">
                       <div class="text-center q-mb-md">
                         <q-img :src="require('../../assets/sgcc-black.png')" basic width="320px" class="items-center"></q-img>
                         <p class="hris-page-subtitle" style="margin: 8px auto 0; text-align: center;">West Avenue, Barangay Paltok, Quezon, Philippines</p>
                       </div>
                        <div class="row">
                           <div class="col-12 col-lg-12 col-xs-12 col-sm-12 q-mb-md q-pr-xl">
                              <q-markup-table separator="none" flat>
                                 <tbody>
                                   <tr>
                                     <td class="text-right text-subtitle2">Employee Name:</td>
                                     <td class="text-left"><q-input v-model="name" dense readonly /></td>
                                     <td class="text-right text-subtitle2">Account:</td>
                                     <td class="text-left"><q-input v-model="account" dense readonly/></td>
                                   </tr>
                                   <tr>
                                     <td class="text-right text-subtitle2">Date of interview</td>
                                     <td class="text-left"><q-input v-model="date_interview" dense readonly/></td>
                                     <td class="text-right text-subtitle2">Position:</td>
                                     <td class="text-left"><q-input v-model="position" dense readonly/></td>
                                   </tr>
                                   <tr>
                                     <td class="text-right text-subtitle2">Date hired</td>
                                     <td class="text-left"><q-input v-model="date_hired" dense readonly/></td>
                                     <td class="text-right text-subtitle2">Immediate Head:</td>
                                     <td class="text-left"><q-input v-model="immediate_head" dense readonly/></td>
                                   </tr>
                                 </tbody>
                               </q-markup-table>
                           </div>
                        </div>
                        <p class="hris-form-banner">Your honest and constructive feedback will go a long way. This will help the organization identify strengths and areas for improvement.</p>
            </div>

            <div class="hris-form-section">
                           <p class="hris-form-section-title">Reason/s for Resignation</p>
                           <div class="row">
                             <div class="col-3 col-lg-3 col-xs-12 col-md-6 q-mb-md q-pr-xl">
                                <q-checkbox v-model="reasons.betterCompensationPackage" size="lg" label="Better compensation package"/>
                                <q-checkbox v-model="reasons.careerChange" size="lg" label="Career change"/>
                             </div>
                             <div class="col-3 col-lg-3 col-xs-12 col-md-6 q-mb-md q-pr-xl">
                                <q-checkbox v-model="reasons.localEmployment" size="lg" label="Local Employment"  />
                                <q-checkbox v-model="reasons.distanceProximity" size="lg" label="Distance or Proximity"  />
                             </div>
                             <div class="col-3 col-lg-3 col-xs-12 col-md-6 q-mb-md q-pr-xl">
                                <q-checkbox v-model="reasons.overseasEmployment" size="lg" label="Overseas Employment"  />
                                <q-checkbox v-model="reasons.personalReason" size="lg" label="Family and/or personal reasons"  />
                             </div>
                             <div class="col-3 col-lg-3 col-xs-12 col-md-6 q-mb-md q-pr-xl">
                                <q-checkbox v-model="reasons.healthIssues" size="lg" label="Health Issues"/>
                             </div>
                          </div>
                          <q-input v-model="reasons.otherReason" label="Others, please specify: " outlined dense color="green" style="max-width: 500px"></q-input>
            </div>

            <div class="hris-form-section">
                          <p class="hris-form-section-title">Tasks, Roles and Responsibilities</p>
                          <div class="col-12 col-lg-12 col-xs-12 col-md-6 q-mb-md q-pr-xl">
                             <q-markup-table separator="none" flat>
                                <thead>
                                <tr>
                                  <th class="text-center"></th>
                                  <th class="text-center">Strongly Disagree</th>
                                  <th class="text-center">Disagree</th>
                                  <th class="text-center">Agree</th>
                                  <th class="text-center">Strongly Agree</th>
                                </tr>
                              </thead>
                                <tbody>
                                  <tr>
                                    <td class="text-left">Job was challenging</td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.jobWasChallenging" val="1"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.jobWasChallenging" val="2"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.jobWasChallenging" val="3"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.jobWasChallenging" val="4"/></td>
                                  </tr>
                                  <tr>
                                    <td class="text-left">Sufficient opportunities for advancement </td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.sufficientOpportunity" val="1"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.sufficientOpportunity" val="2"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.sufficientOpportunity" val="3"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.sufficientOpportunity" val="4"/></td>
                                  </tr>
                                  <tr>
                                    <td class="text-left">Workload was manageable</td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.workloadManageable" val="1"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.workloadManageable" val="2"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.workloadManageable" val="3"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.workloadManageable" val="4"/></td>
                                  </tr>
                                  <tr>
                                    <td class="text-left">Sufficient resources and staff were available</td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.sufficientResources" val="1"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.sufficientResources" val="2"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.sufficientResources" val="3"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.sufficientResources" val="4"/></td>
                                  </tr>
                                  <tr>
                                    <td class="text-left">Skills were effectively used</td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.skillWereEffective" val="1"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.skillWereEffective" val="2"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.skillWereEffective" val="3"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.skillWereEffective" val="4"/></td>
                                  </tr>
                                  <tr>
                                    <td class="text-left">Access to adequate training and development programs </td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.accessToAdequate" val="1"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.accessToAdequate" val="2"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.accessToAdequate" val="3"/></td>
                                    <td class="text-center"><q-radio size="lg" v-model="tasks.accessToAdequate" val="4"/></td>
                                  </tr>
                                </tbody>
                              </q-markup-table>
                              <q-input v-model="tasks.whatCanBeImproved" label="What do you think can be improved about the job?" outlined dense color="green" style="max-width: 500px"></q-input>
                          </div>
            </div>

            <div class="hris-form-section">
                        <p class="hris-form-section-title">Wages &amp; Benefits</p>
                        <div class="col-12 col-lg-12 col-xs-12 col-md-6 q-mb-md q-pr-xl">
                           <q-markup-table separator="none" flat>
                              <thead>
                              <tr>
                                 <th class="text-center"></th>
                                 <th class="text-center">Strongly Disagree</th>
                                 <th class="text-center">Disagree</th>
                                 <th class="text-center">Agree</th>
                                 <th class="text-center">Strongly Agree</th>
                              </tr>
                             </thead>
                              <tbody>
                                 <tr>
                                   <td class="text-left">Adequate salary in relation to responsibilities</td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.adequateSalary" val="1"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.adequateSalary" val="2"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.adequateSalary" val="3"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.adequateSalary" val="4"/></td>
                                 </tr>
                                 <tr>
                                   <td class="text-left">Wages were paid on time</td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.wagesPaid" val="1"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.wagesPaid" val="2"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.wagesPaid" val="3"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.wagesPaid" val="4"/></td>
                                 </tr>
                                 <tr>
                                   <td class="text-left">Company benefits were good </td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.companyBenefits" val="1"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.companyBenefits" val="2"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.companyBenefits" val="3"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.companyBenefits" val="4"/></td>
                                 </tr>
                                 <tr>
                                   <td class="text-left">Work-life balance promoted and practiced</td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.workLikeBalance" val="1"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.workLikeBalance" val="2"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.workLikeBalance" val="3"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.workLikeBalance" val="4"/></td>
                                 </tr>
                                 <tr>
                                   <td class="text-left">Merit increase reflects performance and contributions to the company</td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.meritIncrease" val="1"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.meritIncrease" val="2"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.meritIncrease" val="3"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.meritIncrease" val="4"/></td>
                                 </tr>
                                 <tr>
                                   <td class="text-left">Highly satisfied with employee services (Pantry, Clinic & Gym)</td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.highlySatisfied" val="1"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.highlySatisfied" val="2"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.highlySatisfied" val="3"/></td>
                                   <td class="text-center"><q-radio size="lg" v-model="wages.highlySatisfied" val="4"/></td>
                                 </tr>
                              </tbody>
                             </q-markup-table>
                             <q-input v-model="wages.whatImprovement" label="What improvements, other benefits could the company offer?" outlined dense color="green" style="max-width: 500px"></q-input>
                        </div>
            </div>

            <div class="hris-form-section">
                      <p class="hris-form-section-title">The Organization</p>
                      <div class="col-12 col-lg-12 col-xs-12 col-md-6 q-mb-md q-pr-xl">
                         <q-markup-table separator="none" flat>
                            <thead>
                            <tr>
                               <th class="text-center"></th>
                               <th class="text-center">Strongly Disagree</th>
                               <th class="text-center">Disagree</th>
                               <th class="text-center">Agree</th>
                               <th class="text-center">Strongly Agree</th>
                            </tr>
                           </thead>
                            <tbody>
                               <tr>
                                 <td class="text-left">Favorable and encouraging workplace</td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.favorable" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.favorable" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.favorable" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.favorable" val="4"/></td>
                               </tr>
                               <tr>
                                 <td class="text-left">Appropriate tools and equipment for the tasks</td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.appropriateTools" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.appropriateTools" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.appropriateTools" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.appropriateTools" val="4"/></td>
                               </tr>
                               <tr>
                                 <td class="text-left">Fosters positive relationships</td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.fosterPositive" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.fosterPositive" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.fosterPositive" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.fosterPositive" val="4"/></td>
                               </tr>
                               <tr>
                                 <td class="text-left">Sufficient staff to cover workload</td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.sufficientStaff" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.sufficientStaff" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.sufficientStaff" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.sufficientStaff" val="4"/></td>
                               </tr>
                               <tr>
                                 <td class="text-left">Effective internal communication</td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.effectiveEternal" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.effectiveEternal" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.effectiveEternal" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.effectiveEternal" val="4"/></td>
                               </tr>
                               <tr>
                                 <td class="text-left">Respectful and harassment-free</td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.respectfulandHarrassment" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.respectfulandHarrassment" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.respectfulandHarrassment" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.respectfulandHarrassment" val="4"/></td>
                               </tr>
                               <tr>
                                 <td class="text-left">Fair treatment without discrimination</td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.fairTreatment" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.fairTreatment" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.fairTreatment" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="organization.fairTreatment" val="4"/></td>
                               </tr>
                            </tbody>
                           </q-markup-table>
                           <q-input v-model="organization.whatDoYouThink" label="What do you think can be improved about the Department and Company?" outlined dense color="green" style="max-width: 500px"></q-input>
                      </div>
            </div>

            <div class="hris-form-section">
                      <p class="hris-form-section-title">Management (Manager / Supervisor / TL)</p>
                      <div class="col-12 col-lg-12 col-xs-12 col-md-6 q-mb-md q-pr-xl">
                         <q-markup-table separator="none" flat>
                            <thead>
                            <tr>
                               <th class="text-center"></th>
                               <th class="text-center">Strongly Disagree</th>
                               <th class="text-center">Disagree</th>
                               <th class="text-center">Agree</th>
                               <th class="text-center">Strongly Agree</th>
                            </tr>
                           </thead>
                            <tbody>
                               <tr>
                                 <td class="text-left">Sufficient knowledge of the job</td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.sufficientKnowledge" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.sufficientKnowledge" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.sufficientKnowledge" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.sufficientKnowledge" val="4"/></td>
                               </tr>
                               <tr>
                                 <td class="text-left">Gives fair and equal treatment</td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.givesFair" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.givesFair" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.givesFair" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.givesFair" val="4"/></td>
                               </tr>
                               <tr>
                                 <td class="text-left">Offers and promotes ways to develop</td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.offerAndPromote" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.offerAndPromote" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.offerAndPromote" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.offerAndPromote" val="4"/></td>
                               </tr>
                               <tr>
                                 <td class="text-left">Provides constructive feedback</td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.provideConstructive" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.provideConstructive" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.provideConstructive" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.provideConstructive" val="4"/></td>
                               </tr>
                               <tr>
                                 <td class="text-left">Receptive to open communication</td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.receptive" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.receptive" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.receptive" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.receptive" val="4"/></td>
                               </tr>
                               <tr>
                                 <td class="text-left">Maintains a professional relationship</td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.maintain" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.maintain" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.maintain" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.maintain" val="4"/></td>
                               </tr>
                               <tr>
                                 <td class="text-left">Recognizes and acknowledges achievements</td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.recognizes" val="1"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.recognizes" val="2"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.recognizes" val="3"/></td>
                                 <td class="text-center"><q-radio size="lg" v-model="management.recognizes" val="4"/></td>
                               </tr>
                            </tbody>
                           </q-markup-table>
                           <q-input v-model="management.yourSuggestions" label="What are your suggestions for improvement to your Manager/Supervisor/TL?" outlined dense color="green" style="max-width: 600px"></q-input>
                      </div>
            </div>

            <div class="hris-form-section hris-form-narrow" style="text-align: center;">
                     <p class="hris-form-section-title">Are there other things you'd like to tell us? Please feel free to share it/them with us.</p>
                     <q-input v-model="remarks" outlined color="green" type="textarea"></q-input>
                     <p class="hris-page-subtitle" style="margin: 16px auto 0; text-align: center;">Thank you for providing this information. Your responses will be kept confidential.</p>
                     <div class="hris-form-actions" style="justify-content: center;">
                       <q-btn unelevated class="hris-q-primary" @click="submitInterview" label="Submit Answer" size="lg"></q-btn>
                     </div>
            </div>
        </div>

        <q-dialog v-model="confirm" persistent>
          <div class="hris-modal">
            <div class="hris-modal-header">
              <h2 class="hris-modal-title">Confirm Submission</h2>
              <q-btn icon="fas fa-times" flat round dense v-close-popup class="hris-q-ghost"></q-btn>
            </div>
            <div class="hris-modal-body">
              <p>Please make sure all questions are answered!</p>
            </div>
            <div class="hris-modal-footer">
              <q-btn flat label="Cancel" class="hris-q-ghost" v-close-popup></q-btn>
              <q-btn unelevated label="I Agree" class="hris-q-primary" @click="confirmSubmission()"></q-btn>
            </div>
          </div>
        </q-dialog>
    </div>
</template>

<script>

import axios from 'axios'
import moment from "moment";

export default{
    data(){
        return{
            employee_id:'',
            name:'',
            account:'',
            date_interview:'',
            position:'',
            date_hired:'',
            immediate_head:'',

            reasons:{
               betterCompensationPackage: false,
               localEmployment: false,
               overseasEmployment: false,
               healthIssues: false,
               careerChange: false,
               distanceProximity: false,
               personalReason: false,
               otherReason: '',
            },

            //Tasks, Roles and Responsibilities
            tasks:{
               jobWasChallenging: '',
               sufficientOpportunity: '',
               workloadManageable: '',
               sufficientResources: '',
               skillWereEffective: '',
               accessToAdequate: '',
               whatCanBeImproved: '',
            },

            //Wages & Benefits
            wages:{
               adequateSalary: '',
               wagesPaid: '',
               companyBenefits: '',
               workLikeBalance: '',
               meritIncrease: '',
               highlySatisfied: '',
               whatImprovement: '',
            },

            //The Organization
            organization:{
               favorable: '',
               appropriateTools: '',
               fosterPositive: '',
               sufficientStaff: '',
               effectiveEternal: '',
               respectfulandHarrassment: '',
               fairTreatment: '',
               whatDoYouThink: '',
            },

            //Management (Manager / Supervisor / TL)
            management:{
               sufficientKnowledge: '',
               givesFair: '',
               offerAndPromote: '',
               provideConstructive: '',
               receptive: '',
               maintain: '',
               recognizes: '',
               yourSuggestions: '',
            },
            remarks:"",
            confirm:false

        }
    },
    methods: {
        searchEmployee:function(){
            let formData = new FormData();
            formData.append("employee_id", this.employee_id);
    		axios.create({
                baseURL: this.apiUrl,
                headers: { 'Authorization': `Bearer ${this.token}` }
            }).post(`/employee/search`, formData).then((res) => {

               if(!res.data.status){
                  this.$q.notify({
                    message: res.data.message,
                    color: 'negative',
                    position:'center',
                    actions: [
                      { label: 'Close', color: 'white', handler: () => { /* ... */ } }
                    ]
                 });
              }else{
                 this.name = res.data.data.name
                 this.account = res.data.data.account
                 this.date_interview = res.data.data.date_interview
                 this.position = res.data.data.position
                 this.date_hired = res.data.data.date_hired
                 this.immediate_head = res.data.data.immediate_head
              }

            });
        },

        submitInterview:function(){
            this.confirm = true
        },

        confirmSubmission:function(){
            let formData = new FormData();
            formData.append("employee_id", this.employee_id);
            formData.append("reasons", JSON.stringify(this.reasons));
            formData.append("tasks", JSON.stringify(this.tasks));
            formData.append("wages", JSON.stringify(this.wages));
            formData.append("organization", JSON.stringify(this.organization));
            formData.append("management", JSON.stringify(this.management));
            formData.append("remarks", this.remarks);
       		axios.create({
                baseURL: this.apiUrl,
                headers: { 'Authorization': `Bearer ${this.token}`,'Content-Type': 'application/json'}
            }).post(`/employee/interview`, formData).then((res) => {
               this.confirm = false
               this.clearData();
               this.$q.notify({
                 message: res.data.message,
                 color: 'positive',
                 position:'center',
                 actions: [
                   { label: 'Close', color: 'white', handler: () => { /* ... */ } }
                 ]
              });
            });
        },

        clearData:function(){
           this.employee_id = '',
           this.name = '',
           this.account = '',
           this.date_interview = '',
           this.position = '',
           this.date_hired = '',
           this.immediate_head = '',

           this.reasons.betterCompensationPackage = false,
           this.reasons.localEmployment = false,
           this.reasons.overseasEmployment = false,
           this.reasons.healthIssues = false,
           this.reasons.careerChange = false,
           this.reasons.distanceProximity = false,
           this.reasons.personalReason = false,
           this.reasons.otherReason = '',

           //Tasks, Roles and Responsibilities
           this.tasks = {},

           //Wages & Benefits
           this.wages = {},

           //The Organization
           this.organization = {},

           //Management (Manager / Supervisor / TL)
           this.management = {},
           this.remarks = "",
           this.confirm = false
        }
    },

    mounted(){

    }
}
</script>
